import React from "react";

import Form from "@Components/Form";
import { URLS, WORKER_GROUP_URL, ESTATE_FETCH_URL } from "configs/constants";

const initialValues = {
  // status: "",
  name: "",
  group_id: "",
  estate: "",
  active: false,
};

const AttendanceWorkerGroupForm = () => {
  const formFields = [
    {
      type: "input",
      name: "group_id",
      label: "Code",
      required: true,
    },
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      required: true,
       proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
    },
    {
      type: "switch",
      name: "active",
      label: "Active?",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  // let module = getAssignedModule(location.pathname);
  // let actionPermission = false;
  // if (!module || module === "") {
  //   actionPermission = true;
  // } else {
  //   let updatedModules = JSON.parse(
  //     localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
  //   );
  //   if (updatedModules[module]) {
  //     let modulePermissions = updatedModules[module].map((perm) => {
  //       if (typeof perm === "string") {
  //         return perm.toLowerCase();
  //       }
  //       return perm;
  //     });
  //     if (modulePermissions.includes("change status")) {
  //       actionPermission = true;
  //     }
  //   }
  // }
  // if (actionPermission) {
  //   formFields.push({
  //     type: "switch",
  //     name: "active",
  //     label: "Active?",
  //     required: true,
  //     nolabel: "No",
  //     yeslabel: "Yes",
  //   });
  // }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={WORKER_GROUP_URL}
      listRoute={URLS.WORKER_GROUP}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Worker Group"
    />
  );
};

export default AttendanceWorkerGroupForm;
